import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

const getAuthToken = () => {
  return sessionStorage.getItem("token") || localStorage.getItem("token");
};

const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ==================== SAVE BUSINESS TOOL CONTENT ====================
export const saveBusinessToolContent = async (data) => {
  try {
    const response = await apiClient.post("/detectors/business-tools-save", data);
    return response.data;
  } catch (error) {
    console.error("Error saving business tool content:", error);
    throw error.response?.data || error;
  }
};

// ==================== GET BUSINESS TOOLS HISTORY ====================
export const getBusinessToolsHistory = async (userId, machineId, toolId = null) => {
  try {
    const response = await apiClient.post("/detectors/business-tools-history", {
      userId,
      machineId,
      toolId,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching business tools history:", error);
    throw error.response?.data || error;
  }
};

// ==================== GET SINGLE SAVED CONTENT ====================
export const getBusinessToolById = async (id, userId, machineId) => {
  try {
    const params = new URLSearchParams();
    if (userId) params.append("userId", userId);
    if (machineId) params.append("machineId", machineId);
    const response = await apiClient.get(`/detectors/business-tools/${id}?${params}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching business tool content:", error);
    throw error.response?.data || error;
  }
};

// ==================== UPDATE SAVED CONTENT ====================
export const updateBusinessToolContent = async (id, data) => {
  try {
    const response = await apiClient.put(`/detectors/business-tools-update/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating business tool content:", error);
    throw error.response?.data || error;
  }
};

// ==================== DELETE SAVED CONTENT ====================
export const deleteBusinessToolContent = async (id) => {
  try {
    const response = await apiClient.delete(`/detectors/business-tools-delete/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting business tool content:", error);
    throw error.response?.data || error;
  }
};

// ==================== TOGGLE STAR STATUS ====================
export const toggleStarBusinessTool = async (id, isStarred) => {
  try {
    const response = await apiClient.put(`/detectors/business-tools-star/${id}`, { isStarred });
    return response.data;
  } catch (error) {
    console.error("Error toggling star status:", error);
    throw error.response?.data || error;
  }
};

// ==================== GET BUSINESS TOOLS STATISTICS ====================
export const getBusinessToolsStats = async (userId, machineId) => {
  try {
    const params = new URLSearchParams();
    if (userId) params.append("userId", userId);
    if (machineId) params.append("machineId", machineId);
    const response = await apiClient.get(`/detectors/business-tools-stats?${params}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching business tools stats:", error);
    throw error.response?.data || error;
  }
};

// ==================== GET SAVED CONTENT BY TOOL TYPE ====================
export const getBusinessToolsByTool = async (userId, machineId, toolId) => {
  try {
    const response = await apiClient.post("/detectors/business-tools-history", {
      userId,
      machineId,
      toolId,
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching ${toolId} history:`, error);
    throw error.response?.data || error;
  }
};

// ==================== GET STARRED CONTENT ====================
export const getStarredBusinessTools = async (userId, machineId) => {
  try {
    const response = await apiClient.post("/detectors/business-tools-history", {
      userId,
      machineId,
    });
    if (response.success) {
      response.data = response.data.filter(item => item.isStarred === true);
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching starred content:", error);
    throw error.response?.data || error;
  }
};

// Export all functions as default object
export default {
  saveBusinessToolContent,
  getBusinessToolsHistory,
  getBusinessToolById,
  updateBusinessToolContent,
  deleteBusinessToolContent,
  toggleStarBusinessTool,
  getBusinessToolsStats,
  getBusinessToolsByTool,
  getStarredBusinessTools,
};